import type { Sidebar } from '@/models/sidebar';
import type { SidebarField } from '@/models/sidebar-field';
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import axios from 'axios';

export const sidebarsQueryOptions = (entityTypeId: string) => {
  return queryOptions({
    queryKey: ['sidebars', entityTypeId],
    queryFn: async () => {
      const response = await axios.get<Sidebar>(`/sidebars/${entityTypeId}`);

      return response.data;
    },
  });
};

export const availableSidebarFieldsQueryOptions = (entityTypeId: string) => {
  return queryOptions({
    queryKey: ['sidebar-fields', entityTypeId],
    queryFn: async () => {
      const response = await axios.get<SidebarField[]>(
        `/${entityTypeId}/sidebar-fields`
      );

      return response.data;
    },
  });
};

export const updateSidebarMutation = (entityTypeId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (sidebar: Sidebar) => {
      const response = await axios.put<Sidebar>(
        `/sidebars/${entityTypeId}`,
        sidebar
      );
      return response.data;
    },
    onSuccess: () => {
      // Invalidate the sidebar query to refetch the updated data
      queryClient.invalidateQueries({ queryKey: ['sidebars', entityTypeId] });
    },
  });
};
